import { render, staticRenderFns } from "./product-history.vue?vue&type=template&id=494709a2&scoped=true"
import script from "./product-history.vue?vue&type=script&lang=js"
export * from "./product-history.vue?vue&type=script&lang=js"
import style0 from "./product-history.vue?vue&type=style&index=0&id=494709a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494709a2",
  null
  
)

export default component.exports